// App root. Decides which screen to show based on auth state and route.
// - /api/auth/setup-status: open   -> SetupScreen
// - not authenticated             -> LoginScreen
// - /                              -> SaleView (the caja)
// - /admin/products                -> AdminProductsView
// - /admin/operators               -> AdminOperatorsView
// - /sales                         -> SalesHistoryView
// - /sales/:id                     -> SaleDetailView
// - /summary                       -> DailySummaryView
// - /customers                     -> CustomerListView
// - /customers/:id                 -> CustomerAccountView
// - /liquidaciones                 -> SettlementsView
// - /liquidaciones/:id             -> SettlementDetailView

import { Navigate, Route, Routes } from "react-router-dom";
import { useSetupStatus, useMe } from "./features/auth/hooks";
import { SetupScreen } from "./features/auth/SetupScreen";
import { LoginScreen } from "./features/auth/LoginScreen";
import { SaleView } from "./features/sale/SaleView";
import { ConsignmentsView } from "./features/consignments/ConsignmentsView";
import { AdminProductsView } from "./features/products/AdminProductsView";
import { Logo } from "./components/Logo";
import { SalesHistoryView } from "./features/sales/SalesHistoryView";
import { SaleDetailView } from "./features/sales/SaleDetailView";
import { DailySummaryView } from "./features/sales/DailySummaryView";
import { CustomerListView } from "./features/customers/CustomerListView";
import { CustomerAccountView } from "./features/customers/CustomerAccountView";
import { AdminOperatorsView } from "./features/admin/operators/AdminOperatorsView";
import { AppShell } from "./components/AppShell";
import { AdminCategoriesView } from "./features/categories/AdminCategoriesView";
import { MoreView } from "./features/navigation/MoreView";
import { AdminSizeGuidesView } from "./features/size-guides/AdminSizeGuidesView";
import { AdminPaymentMethodsView } from "./features/payment-methods/AdminPaymentMethodsView";
import { SettlementsView } from "./features/settlements/SettlementsView";
import { SettlementDetailView } from "./features/settlements/SettlementDetailView";

function Loading() {
  return (
    <main
      style={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Logo height={32} />
    </main>
  );
}

export function App() {
  const setupStatus = useSetupStatus();
  const me = useMe(!!setupStatus.data && setupStatus.data.setupOpen === false);

  if (setupStatus.isLoading || me.isLoading) {
    return <Loading />;
  }

  if (setupStatus.data?.setupOpen) {
    return <SetupScreen />;
  }

  if (!me.data) {
    return <LoginScreen />;
  }

  return (
    <AppShell operatorName={me.data.name}>
      <Routes>
        <Route path="/" element={<SaleView />} />
        <Route path="/consignaciones" element={<ConsignmentsView />} />
        <Route path="/consignaciones/:id/editar" element={<SaleView />} />
        <Route path="/admin/products" element={<AdminProductsView />} />
        <Route path="/admin/categories" element={<AdminCategoriesView />} />
        <Route path="/admin/size-guides" element={<AdminSizeGuidesView />} />
        <Route path="/admin/payment-methods" element={<AdminPaymentMethodsView />} />
        <Route path="/admin/operators" element={<AdminOperatorsView />} />
        <Route path="/sales" element={<SalesHistoryView />} />
        <Route path="/sales/:id" element={<SaleDetailView />} />
        <Route path="/summary" element={<DailySummaryView />} />
        <Route path="/customers" element={<CustomerListView />} />
        <Route path="/customers/:id" element={<CustomerAccountView />} />
        <Route path="/liquidaciones" element={<SettlementsView />} />
        <Route path="/liquidaciones/:id" element={<SettlementDetailView />} />
        <Route path="/more" element={<MoreView />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
